import { CardType } from 'components/Card';

export enum ChoiceType {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}

export type InitialCategoriesType = 'all';

export type UseFiltersType = (
  items: CardType[],
  initialCategories: InitialCategoriesType,
  choiceType?: ChoiceType
) => {
  selectedCategories: string[];
  sortedItems: CardType[];
  allTags: string[];
  handleSelectedCategories: (tagName: string) => void;
};
